var _objectAssign = /*#__PURE__*/require('./_objectAssign');

module.exports = typeof Object.assign === 'function' ? Object.assign : _objectAssign;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_assign.js
// module id = 4047
// module chunks = 168707334958949